import { GET_ALL_CALLS } from 'src/api/graphql/queries/calls.gql';
import { fetchList } from './fetchLists';
import {
	pickFilters,
	prepareGraphqlFilters,
} from 'src/utils/helpers/prepareGraphqlFilters';

export const getAllCalls = async ({
	page = 1,
	limit = 15,
	sort,
	filters,
} = {}) => {
	return fetchList({
		query: GET_ALL_CALLS,
		variables: {
			page,
			limit,
			sort,
			filters: pickFilters(prepareGraphqlFilters(filters), [
				'id',
				'externalId',
				'company',
				'companyGorkoId',
				'createdBy',
				'companyName',
				'createdByName',
				'createdAt',
				'updatedAt',
			]),
		},
		addPerPage: true,
	});
};
